/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftDownIcon24Regular = forwardRef('ArrowDUturnLeftDownIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6.125 11a7.875 7.875 0 0 1 15.75 0v6a.875.875 0 1 1-1.75 0v-6a6.125 6.125 0 0 0-12.25 0v7.064l4.137-4.412a.875.875 0 1 1 1.276 1.196l-4.53 4.833c-.939 1.001-2.527 1.001-3.466 0l-4.53-4.833a.875.875 0 1 1 1.276-1.196l4.087 4.359V11Z" })));
});
